import { Box } from "@mui/material"
import { PasswordlessSignInContainer } from "auth/containers/PasswordlessSignInContainer"

// Dev-only: floats over the auth page instead of stacking above the
// full-height panel, which would add scroll height to the page.
export const DevPasswordlessOverlay = () => {
  if (
    typeof window === "undefined" ||
    !window.location.origin.includes("localhost")
  ) {
    return null
  }
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 10,
        backgroundColor: "white",
      }}
    >
      <PasswordlessSignInContainer />
    </Box>
  )
}
